import React, { PureComponent } from 'react'
import { Button, FormCheck } from 'react-bootstrap'
import QRCode from 'qrcode.react'
import { STORAGE_TYPE_LOCAL } from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'
import PasswordResetSection from './password_reset_section'

const emailRegexp =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

class ProfileComponent extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      business: '',
      email: '',
      first_name: '',
      last_name: '',
      is_active: '',
      is_staff: '',
      groups: '',
      username: '',

      localTime: StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem('localTime') === 'true',
    }
    this.mfaCodeRef = React.createRef()
    props.checkMfaStatus()
  }

  changeHandler = ({ target }) => this.setState({ [target.name]: target.value, formChanged: true })

  componentDidMount() {
    const { user } = this.props
    this.setState({
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      is_staff: user.is_staff,
      username: user.username,
    })
  }

  isValidForm = () => this.isValidEmail()

  isValidEmail = () => emailRegexp.test(this.state.email)

  handleUpdateUser = async () => {
    const { props, state } = this
    const profile = {
      email: state.email,
      first_name: state.first_name,
      last_name: state.last_name,
      is_staff: state.is_staff,
      username: state.username,
    }
    StorageProviderFactory.create(STORAGE_TYPE_LOCAL).setItem('localTime', state.localTime)
    await props.updateProfile(profile)
  }

  disableMfa = async () => {
    const { disableMfa, checkMfaStatus } = this.props
    await disableMfa()
    await checkMfaStatus()
  }

  changeLocalTimeHandler = ({ target }) => this.setState({ localTime: target.checked })

  activateMfa = () => this.props.activateMfa()

  mfaManager = () => {
    /**
     * we don't want to show this button now
     * cause we don’t have a policy on this
     * so we just don't render this for now
     */
    const { confirmMfa, qrLink, mfaStatus, checkMfaStatus, confirmMfaError } = this.props
    if (!mfaStatus) {
      return null
    }
    return (
      <div>
        {qrLink && <QRCode style={{ marginBottom: 5 }} value={qrLink} />}
        {qrLink && (
          <div>
            <input className='form-control input-md' type='text' placeholder='Code from an app' ref={this.mfaCodeRef} />
            <p>You can scan this code with Authy App or Google Authenticator</p>
            <Button
              variant='primary'
              onClick={() => {
                if (this.mfaCodeRef.current.value.length > 0) {
                  confirmMfa(this.mfaCodeRef.current.value).then(() => {
                    checkMfaStatus()
                  })
                }
              }}
            >
              Enable Two-factor authentication
            </Button>
            {confirmMfaError && <div className='alert alert-danger'>{confirmMfaError}</div>}
          </div>
        )}
      </div>
    )
  }

  render() {
    const { state } = this
    const {
      getUser,
      isFetching,
      mfaStatus,
      user,
      requestPasswordResetCode,
      confirmPasswordReset,
      logoutUser,
      isRequestingCode,
      isConfirming,
    } = this.props
    return (
      <form className='form-horizontal'>
        <fieldset>
          <legend>User profile</legend>
          <div className={`form-group ${this.isValidEmail() ? '' : 'has-error'}`}>
            <label className='col-md-4 control-label' htmlFor='email'>
              Email Address
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-envelope-o' />
                </div>
                <input
                  id='email'
                  name='email'
                  type='email'
                  placeholder='Email Address'
                  required
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.email}
                />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='first_name'>
              First Name
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-users' />
                </div>
                <input
                  id='first_name'
                  name='first_name'
                  placeholder='First Name'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.first_name}
                />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='last_name'>
              Last Name
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-male' />
                </div>
                <input
                  id='last_name'
                  name='last_name'
                  placeholder='Last Name'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.last_name}
                />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='groups'>
              Groups
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-user' />
                </div>
                <input
                  id='groups'
                  name='groups'
                  placeholder='Groups'
                  className='form-control input-md'
                  value={state.groups}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='2fa'>
              Use Local Time
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <FormCheck checked={this.state.localTime} onChange={this.changeLocalTimeHandler} name={'localTime'} />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='2fa'>
              Two-factor authentication
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                {mfaStatus === 'Enabled' ? (
                  <Button variant='primary' className='pull-right' onClick={this.disableMfa}>
                    Disable MFA
                  </Button>
                ) : (
                  <Button variant='primary' className='pull-right' onClick={this.activateMfa}>
                    Activate MFA
                  </Button>
                )}
              </div>
              {this.mfaManager()}
            </div>
          </div>
          <PasswordResetSection
            email={user.email}
            requestPasswordResetCode={requestPasswordResetCode}
            confirmPasswordReset={confirmPasswordReset}
            logoutUser={logoutUser}
            isRequestingCode={isRequestingCode}
            isConfirming={isConfirming}
          />
          <div className='form-group'>
            <label className='col-md-4 control-label' />
            <div className='col-md-4'>
              <Button onClick={getUser} variant={'default'}>
                Cancel
              </Button>
              &nbsp;
              <Button variant='primary' onClick={this.handleUpdateUser} disabled={isFetching || !this.isValidForm()}>
                Save changes
              </Button>
            </div>
          </div>
        </fieldset>
      </form>
    )
  }
}

export default ProfileComponent
